const currencySymbols = {
  'AED': 'د.إ', // UAE Dirham
  'AFN': '؋', // Afghan Afghani
  'ALL': 'L', // Albanian Lek
  'AMD': '֏', // Armenian Dram
  'ANG': 'ƒ', // Netherlands Antillean Guilder
  'AOA': 'Kz', // Angolan Kwanza
  'ARS': '$', // Argentine Peso
  'AUD': '$', // Australian Dollar
  'AWG': 'Afl', // Aruban Florin
  'AZN': '₼', // Azerbaijani Manat
  'BAM': 'KM', // Bosnia and Herzegovina Convertible Mark
  'BBD': '$', // Barbadian Dollar
  'BDT': '৳', // Bangladeshi Taka
  'BGN': 'лв', // Bulgarian Lev
  'BHD': 'د.ب', // Bahraini Dinar
  'BIF': 'FBu', // Burundian Franc
  'BMD': '$', // Bermudian Dollar
  'BND': '$', // Brunei Dollar
  'BOB': 'b', // Bolivian Boliviano
  'BRL': '$', // Brazilian Real
  'BSD': '$', // Bahamian Dollar
  'BTN': 'Nu.', // Bhutanese Ngultrum
  'BWP': 'P', // Botswanan Pula
  'BYN': 'Br', // Belarusian Ruble
  'BZD': '$', // Belize Dollar
  'CAD': '$', // Canadian Dollar
  'CDF': 'FC', // Congolese Franc
  'CHF': 'CHF ', // Swiss Franc
  'CLP': '$', // Chilean Peso
  'CNY': '¥', // Chinese Yuan
  'COP': '$', // Colombian Peso
  'CRC': '₡', // Costa Rican Colón
  'CUP': '₱', // Cuban Peso
  'CV': 'Esc', // Cape Verdean Escudo
  'CZK': 'Kč', // Czech Koruna
  'DJF': 'Fdj', // Djiboutian Franc
  'DKK': 'kr', // Danish Krone
  'DOP': '$', // Dominican Peso
  'DZD': 'د.ج', // Algerian Dinar
  'EGP': 'ج.م', // Egyptian Pound
  'ERN': 'Nfk', // Eritrean Nakfa
  'ETB': 'Br', // Ethiopian Birr
  'EUR': '€', // Euro
  'FJD': '$', // Fijian Dollar
  'FKP': '£', // Falkland Islands Pound
  'GBP': '£', // British Pound Sterling
  'GEL': '₾', // Georgian Lari
  'GHS': '₵', // Ghanaian Cedi
  'GIP': '£', // Gibraltar Pound
  'GMD': 'D', // Gambian Dalasi
  'GNF': 'FG', // Guinean Franc
  'GTQ': 'Q', // Guatemalan Quetzal
  'GYD': '$', // Guyanaese Dollar
  'HKD': '$', // Hong Kong Dollar
  'HNL': 'L', // Honduran Lempira
  'HRK': 'kn', // Croatian Kuna
  'HTG': 'G', // Haitian Gourde
  'HUF': 'Ft', // Hungarian Forint
  'IDR': 'Rp', // Indonesian Rupiah
  'ILS': '₪', // Israeli New Shekel
  'INR': '₹', // Indian Rupee
  'IQD': 'د.ع', // Iraqi Dinar
  'IRR': '﷼', // Iranian Rial
  'ISK': 'kr', // Icelandic Króna
  'JMD': '$', // Jamaican Dollar
  'JOD': 'د.ا', // Jordanian Dinar
  'JPY': '¥', // Japanese Yen
  'KES': 'KSh', // Kenyan Shilling
  'KGS': 'лв', // Kyrgyzstani Som
  'KHR': '៛', // Cambodian Riel
  'KMF': 'CF', // Comorian Franc
  'KRW': '₩', // South Korean Won
  'KWD': 'د.ك', // Kuwaiti Dinar
  'KYD': '$', // Cayman Islands Dollar
  'KZT': '₸', // Kazakhstani Tenge
  'LAK': '₭', // Laotian Kip
  'LBP': 'ل.ل', // Lebanese Pound
  'LKR': 'Rs', // Sri Lankan Rupee
  'LRD': '$', // Liberian Dollar
  'LSL': 'M', // Lesotho Loti
  'LTL': 'Lt', // Lithuanian Litas
  'LVL': 'Ls', // Latvian Lats
  'LYD': 'ل.د', // Libyan Dinar
  'MAD': 'د.م.', // Moroccan Dirham
  'MDL': 'Lei', // Moldovan Leu
  'MGA': 'Ar', // Malagasy Ariary
  'MKD': 'ден', // Macedonian Denar
  'MMK': 'Ks', // Myanmar Kyat
  'MNT': '₮', // Mongolian Tugrik
  'MOP': 'P', // Macanese Pataca
  'MRU': 'UM', // Mauritanian Ouguiya
  'MUR': '₨', // Mauritian Rupee
  'MVR': '.ރ', // Maldivian Rufiyaa
  'MWK': 'MK', // Malawian Kwacha
  'MXN': '$', // Mexican Peso
  'MYR': 'RM', // Malaysian Ringgit
  'MZN': 'MT', // Mozambican Metical
  'NAD': '$', // Namibian Dollar
  'NGN': '₦', // Nigerian Naira
  'NIO': '$', // Nicaraguan Córdoba
  'NOK': 'kr', // Norwegian Krone
  'NPR': 'Rs', // Nepalese Rupee
  'NZD': '$', // New Zealand Dollar
  'OMR': 'ر.ع.', // Omani Rial
  'PAB': 'B/.', // Panamanian Balboa
  'PEN': 'S/.', // Peruvian Nuevo Sol
  'PGK': 'K', // Papua New Guinean Kina
  'PHP': '₱', // Philippine Peso
  'PKR': '₨', // Pakistani Rupee
  'PLN': 'zł', // Polish Zloty
  'PYG': 'Gs', // Paraguayan Guarani
  'QAR': 'ر.ق', // Qatari Rial
  'RON': 'lei', // Romanian Leu
  'RSD': 'Дин.', // Serbian Dinar
  'RUB': '₽', // Russian Ruble
  'RWF': 'Fr', // Rwandan Franc
  'SAR': 'ر.س', // Saudi Riyal
  'SBD': '$', // Solomon Islands Dollar
  'SCR': '₨', // Seychellois Rupee
  'SEK': 'kr', // Swedish Krona
  'SGD': '$', // Singapore Dollar
  'SHP': '£', // Saint Helena Pound
  'SLL': 'Le', // Sierra Leonean Leone
  'SOS': 'Sh', // Somali Shilling
  'SPL': '₤', // São Tomé and Príncipe Dobra
  'SRD': '$', // Surinamese Dollar
  'SSP': '£', // South Sudanese Pound
  'STN': 'Db', // São Tomé and Príncipe Dobra
  'SYP': '£', // Syrian Pound
  'SZL': 'L', // Swazi Lilangeni
  'THB': '฿', // Thai Baht
  'TJS': 'SM', // Tajikistani Somoni
  'TMT': 'm', // Turkmenistan Manat
  'TND': 'د.ت', // Tunisian Dinar
  'TOP': '$', // Tongan Paʻanga
  'TRY': '₺', // Turkish Lira
  'TTD': '$', // Trinidad and Tobago Dollar
  'TWD': '$', // Taiwan Dollar
  'TZS': 'Sh', // Tanzanian Shilling
  'UAH': '₴', // Ukrainian Hryvnia
  'UGX': 'USh', // Ugandan Shilling
  'USD': '$', // United States Dollar
  'UYU': '$U', // Uruguayan Peso
  'UZS': 'so\'m', // Uzbekistani Som
  'VEF': 'Bs', // Venezuelan Bolívar
  'VND': '₫', // Vietnamese Dong
  'VUV': 'Vt', // Vanuatu Vatu
  'WST': 'T', // Samoan Tala
  'XAF': 'FCFA', // CFA Franc (Central Africa)
  'XCD': '$', // East Caribbean Dollar
  'XOF': 'CFA', // CFA Franc (West Africa)
  'YER': '﷼', // Yemeni Rial
  'ZAR': 'R', // South African Rand
  'ZMK': 'K', // Zambian Kwacha
  'ZWL': '$', // Zimbabwean Dollar
};
const formatMoney = (amount) => {
  const currencyCode = document.querySelector('[cart_currency]')?.getAttribute('cart_currency') || 'USD';
  const amountInCurrency = (amount / 100).toFixed(2).replace(/\.00$/, ''); // Remove .00 if no decimal part
  const symbol = currencySymbols[currencyCode] || '';

  let [whole, decimal] = amountInCurrency.split('.');

  
  whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  
  if (currencyCode === 'EUR') {
    decimal = decimal ? decimal.replace('.', ',') : ''; // Use comma for EUR
  }

  
  let formattedAmount = decimal ? `${whole}.${decimal}` : whole;

  return `${symbol}${formattedAmount}`;
};


const varJson = document.querySelector('.ctm_designed_variants [type="application/json"]');
const variantJson = JSON.parse(varJson.textContent);

const handleVariantChange = () => {
  const input = [...document.querySelectorAll('.ctm_designed_variants input')].find(input => input.checked);
  if (!input) return;

  const allOp = document.querySelectorAll('.ctm_designed_variants .variant-picker__option');
  const labels = [...allOp].pop()?.querySelectorAll('.block-swatch');

  labels?.forEach(label => {
    const selectedOption = [label.getAttribute('option_value')];
    if (allOp.length > 1) selectedOption.unshift(input.value);
    
    const selectedVar = variantJson.find(vr => vr.options?.every((v, i) => v == selectedOption[i]));
    if (!selectedVar) return;

    const comPriceCon = selectedVar.compare_at_price && selectedVar.compare_at_price > selectedVar.price;
    const priceDiscHTML = `
      <span class="money_main">
        <span class="sale_price">${comPriceCon ? formatMoney(selectedVar.compare_at_price) : ''}</span>
        <span class="reg_price">${formatMoney(selectedVar.price)}</span>
      </span>
      <span class="var_discount" style="display: ${comPriceCon ? 'block' : 'none'}">
        ${comPriceCon ? ((selectedVar.compare_at_price - selectedVar.price) * 100 / selectedVar.compare_at_price).toFixed(0) : ''}% ${document.querySelector('[discountName]')?.getAttribute('discountName')}
      </span>
    `;

    if(comPriceCon) label.querySelector('.block-swatch_value')?.setAttribute('price_discount', ((selectedVar.compare_at_price - selectedVar.price) * 100 / selectedVar.compare_at_price).toFixed(2).replace('.00', '') + '% Discount');
    else label.querySelector('.block-swatch_value')?.removeAttribute('price_discount');

    const priceDisc = label.querySelector('.var_price');
    if (priceDisc) {
      priceDisc.innerHTML = priceDiscHTML;
    } else {
      const newPriceDisc = document.createElement('span');
      newPriceDisc.classList.add('var_price');
      newPriceDisc.innerHTML = priceDiscHTML;
      label.append(newPriceDisc);
    }
  });
}

window.addEventListener("load", function(event) {
  handleVariantChange();
  document.querySelectorAll('.ctm_designed_variants input')?.forEach(input => input.addEventListener('change', handleVariantChange));
  
  if(!window.location.href.includes('variant')) document.querySelectorAll('[default_checked]')?.forEach(input => {
    input.checked = true;
    const changeEvent = new Event('change', { bubbles: true, cancelable: true });
    input.dispatchEvent(changeEvent);
  });
});

